export const unitUsahaFormData = (dropdownBidangUsaha, dropdownUsers) => {
    return [
        {
            id      : "id_bidang_usaha",
            label   : "Pilih Bidang Usaha",
            fields  : [{
                type: "option",
                options: dropdownBidangUsaha 
            }]
        },
        {
            id      : "id_penanggung_jawab",
            label   : "Pilih Penanggung Jawab",
            fields  : [{
                type: "option",
                options: dropdownUsers
            }]
        },
        {
            id      : "kode_unit_usaha",
            label   : "Kode Unit Usaha",
            fields  : [{
                type: "input",
                placeholder: "Masukan Kode Unit Usaha",
            }],
        },
        {
            id      : "unit_usaha",
            label   : "Unit Usaha",
            fields  : [{
                type: "input",
                placeholder: "Masukan Kode Unit Usaha",
            },
        ]}
    ]
}